import React, {useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmModal from '../../../components/comm/ConfirmModal';
import URL from '../../../constants/url';
import axiosApi from '../../../api/daonAxios';
import style from './ActivityLevelSelect.module.css';
import iconActivity01 from '../../../images/common/i_activity_01.svg';
import iconActivity02 from '../../../images/common/i_activity_02.svg';
import iconActivity03 from '../../../images/common/i_activity_03.svg';
import CODE from "../../../constants/code";
//import {getCommCdListNew} from "../../../assets/js/comm";


const ACTIVITY_LEVELS = [
    { value: 'SD', icon: iconActivity01, label: '거의 없음', desc: '주로 앉아서 생활' }, // 비활동적
    { value: 'AT', icon: iconActivity02, label: '보통 활동', desc: '일상적인 움직임' }, // 활동적
    { value: 'VA', icon: iconActivity03, label: '활발한 활동', desc: '많은 신체 활동' }, // 매우 활동적
];

const ActivityLevelSelect = ({ userName = '디팜', initialLevel = null, onSave }) => {

    const user = JSON.parse(sessionStorage.getItem('loginUser'));

    //console.log( " ====================> user info :: ", user );

    const navigate = useNavigate();
    const [selected, setSelected] = useState(initialLevel);

    //const [activityLevel, setActivityLevel] = useState([]);

    const [isConfirmOpen, setIsConfirmOpen] = useState(false);

    // 화면초기화 useRef 선언
    //const isInitialRender = useRef(true);

    const handleSelect = useCallback((value) => {
        setSelected(value);
    }, []);

    const handleSaveClick = useCallback(() => {
        if (!selected) return;
        savePhysicalActivity();

    }, [selected]);

    const handleConfirm = useCallback(() => {
        onSave?.(selected);
        setIsConfirmOpen(false);
        savePhysicalActivity();
    }, [selected, onSave]);

    const handleCancel = useCallback(() => {
        setIsConfirmOpen(false);
    }, []);

    /* 기능 활용시 ... // 아이콘이미지 연결시 어차피 데이터 가공이 필요하면, 하드코딩을 활용할것!
        useEffect(() => {
            if(isInitialRender.current) {

                getCommCdListNew("PA_CD")
                    .then( (res) => {
                        // 데이터 가공
                        res.map( (item) => {
                            switch ( item.value) {
                                case "SD" :
                                    item.icon = iconActivity01;
                                    item.label = "거의 없음"; // 라벨 기획과 맞춰주기
                                    break;
                                case "LA" :
                                    //item.icon = iconActivity0x;
                                    //item.label = "저 활동";
                                    break;
                                case "AT" :
                                    item.icon = iconActivity02;
                                    item.label = "보통 활동";
                                    break;
                                case "VA" :
                                    item.icon = iconActivity03;
                                    item.label = "활발한 활동";
                                    break;
                                default :
                                    break;
                            }
                        });
                        setActivityLevel( res );
                    })
                    .catch( (err) => {
                        console.log(err);
                    });
            isInitialRender.current = false;
        }
    }, []);
    */

    //신체활동 단계 저장
    const savePhysicalActivity = () => {

        const requestUrl = '/signup/savePatientPhysicalActivity';

        const jToken = localStorage.getItem("jToken");

        const requestOptions  = {
            headers: {
                //'Content-Type': 'application/json',
                'Authorization': `Bearer ${jToken}`
            },
        };

        const requestBody = {
            "paCd": selected,
            "patntRgstId": user?.usrHsptlMap[0].patntRgstId
        };

        axiosApi.post(requestUrl, requestBody, requestOptions)
            .then((res) => {

                if (Number(res.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
                    const iitpUser = res.data.result.iitpUser;
                    sessionStorage.setItem('loginUser', JSON.stringify(iitpUser));

                    navigate(URL.HOME_MAIN);
                }
            })
            .catch( err => {
                console.log(err);
            });

    };

    return (
        <div className={style.page}>
            {/* 헤더 */}
            <div className={style.header}>
                <h1 className={style.title}>신체 활동량 선택</h1>
            </div>

            {/* 안내 문구 */}
            <p className={style.guide}>
                {userName}님에게 꼭 맞는 권장 칼로리와 운동 기준을<br />
                계산해 드릴게요.
            </p>
            <p className={style.guide}>
                나중에 설정에서 언제든지 변경할 수 있어요.
            </p>

            {/* 활동량 선택 */}
            <div className={style.cardList} role="radiogroup" aria-label="신체 활동량 선택">
                { ACTIVITY_LEVELS.map((lv) => {
                    const active = selected === lv?.value;
                    return (
                        <button
                            key={lv?.value}
                            type="button"
                            role="radio"
                            aria-checked={active}
                            className={style.card}
                            data-active={active}
                            onClick={() => handleSelect(lv?.value)}
                        >
                            <span className={style.cardEmoji} aria-hidden="true">
                                <img src={lv?.icon} alt="활동량 이미지" />
                            </span>
                            <span className={style.cardLabel}>{lv?.label}</span>
                            <span className={style.cardDesc}>{lv?.desc}</span>
                        </button>
                    );
                })}
            </div>

            {/* 저장 버튼 */}
            <div className={style.footer}>
                <button
                    type="button"
                    className={style.saveBtn}
                    disabled={!selected}
                    onClick={handleSaveClick}
                >
                    다음
                </button>
            </div>

            <ConfirmModal
                open={isConfirmOpen}
                title={'신체 활동량을 선택 하시겠습니까?'}
                message={'활동량에 따라 칼로리와\n운동 기준이 함께 변경됩니다.'}
                cancelText={'아니오'}
                confirmText={'네'}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
        </div>
    );
};

export default ActivityLevelSelect;
